import { useEffect, useState } from "react";
import { useInView, Reveal } from "@/lib/reveal";

const STATS = [
  { label: "Happy Clients", value: 150, suffix: "+" },
  { label: "Campaigns Delivered", value: 520, suffix: "+" },
  { label: "Avg. Growth", value: 320, suffix: "%" },
  { label: "Years Combined Expertise", value: 45, suffix: "+" },
];

const Counter = ({ value, suffix, active }) => {
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!active) return undefined;
    const duration = 1800;
    const start = performance.now();
    let raf;
    const step = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3);
      setN(Math.floor(eased * value));
      if (t < 1) raf = requestAnimationFrame(step);
      else setN(value);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [active, value]);

  return (
    <span className="counter">
      {n.toLocaleString()}
      {suffix}
    </span>
  );
};

export const Stats = () => {
  const [ref, inView] = useInView({ threshold: 0.3, once: true });

  return (
    <section
      id="stats"
      data-testid="stats-section"
      ref={ref}
      className="relative py-24 md:py-32 border-t border-white/5 overflow-hidden"
    >
      <div
        className="absolute -top-40 left-1/2 -translate-x-1/2 h-[520px] w-[900px] hero-orb opacity-60"
        aria-hidden="true"
      />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <Reveal>
            <span className="text-xs font-bold tracking-[0.22em] uppercase text-[#FF7B00]">
              — The numbers
            </span>
          </Reveal>
          <Reveal delay={100}>
            <h2 className="font-display mt-4 text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight">
              Growth, receipts, and{" "}
              <span className="text-gradient-gold">repeatable wins.</span>
            </h2>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-6">
          {STATS.map((s, idx) => (
            <Reveal
              key={s.label}
              delay={idx * 120}
              className="rounded-3xl border border-white/5 bg-[#0F0F0F] p-8 md:p-10 hover:border-[#FF7B00]/30 transition-colors"
            >
              <div
                data-testid={`stat-${s.label.toLowerCase().replace(/\s/g, "-")}`}
                className="flex flex-col"
              >
                <div className="font-display text-5xl md:text-6xl lg:text-7xl font-black tracking-tighter text-gradient-gold">
                  <Counter value={s.value} suffix={s.suffix} active={inView} />
                </div>
                <div className="mt-4 text-sm md:text-base font-semibold uppercase tracking-[0.16em] text-zinc-400">
                  {s.label}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
